/**
 * tc-load-more.js — AJAX "Mehr laden" for collection pages
 * Fetches the next page, appends products to the grid, re-triggers GSAP.
 */
(function () {
  'use strict';

  function init() {
    var container = document.getElementById('tc-load-more');
    if (!container) return;

    var btn = container.querySelector('.tc-load-more__btn');
    var spinner = container.querySelector('.tc-load-more__spinner');
    if (!btn) return;

    btn.addEventListener('click', function () {
      var nextUrl = btn.getAttribute('data-next-url');
      if (!nextUrl) return;

      // Show spinner, disable button
      btn.disabled = true;
      btn.hidden = true;
      if (spinner) spinner.hidden = false;

      fetch(nextUrl)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');

          // Extract new grid items
          var newGrid = doc.getElementById('product-grid');
          if (!newGrid) {
            btn.disabled = false;
            btn.hidden = false;
            if (spinner) spinner.hidden = true;
            return;
          }

          var newItems = newGrid.querySelectorAll('.grid__item');
          var currentGrid = document.getElementById('product-grid');

          // Append new items
          var addedItems = [];
          newItems.forEach(function (item) {
            // Remove Dawn scroll-trigger classes to avoid conflicts
            item.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--cancel');
            item.removeAttribute('style');
            currentGrid.appendChild(item);
            addedItems.push(item);
          });

          // Re-trigger GSAP on new items
          if (typeof window.tcInitCollectionGSAP === 'function' && addedItems.length) {
            window.tcInitCollectionGSAP(addedItems);
          }

          // Check if there's another page
          var newLoadMore = doc.getElementById('tc-load-more');
          var newBtn = newLoadMore ? newLoadMore.querySelector('.tc-load-more__btn') : null;

          if (newBtn && newBtn.getAttribute('data-next-url')) {
            // Update next URL and restore button
            btn.setAttribute('data-next-url', newBtn.getAttribute('data-next-url'));
            btn.disabled = false;
            btn.hidden = false;
          } else {
            // No more pages — remove the load more section
            container.remove();
          }

          if (spinner) spinner.hidden = true;
        })
        .catch(function () {
          // On error, restore button
          btn.disabled = false;
          btn.hidden = false;
          if (spinner) spinner.hidden = true;
        });
    });
  }

  // Init on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init after facets AJAX update
  document.addEventListener('tc:grid-updated', function () {
    init();
  });
})();
